import { createContext, useContext } from 'react';

const ScrollContext = createContext(null);

export const useScrollContext = () => {
  const context = useContext(ScrollContext);
  if (!context) {
    console.warn('useScrollContext must be used within a ScrollProvider');
  }
  return context;
};

export const ScrollProvider = ({ scrollerRef, children }) => {
  return (
    <ScrollContext.Provider value={scrollerRef}>
      {children}
    </ScrollContext.Provider>
  );
};

export default ScrollContext;
